import {inject, Injectable, signal} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ClientService} from "@serv/client.service";
import {VehicleService} from "@serv/vehicle.service";
import {AddressService} from "@serv/address.service";
import {Router} from "@angular/router";
import {OsLlmService} from "@llm/service/os_register.service";
//import {LlmStudioService} from "@llm/service/lmstudio2.service";
import {OperationService} from "@serv/operation.service";
import {RoTypeService} from "@serv/ro-type.service";
import {DataService} from "@serv/data.service";
import {PlayMessageService} from "@llm/service/play_message.service";
import {Utiles_ferramentas} from "@llm/utils/utiles_ferramentas";
//import {Agent_ValidateAndSaveDataOS} from "@llm/service/agents_services/ferramenta_cadastro_os.service";
import {ResultIntentSaveDataInterface} from '@llm/utils/agents';
import {InterfaceClientRegister} from "@llm/interfaces/llm_client_register.interface";
import {Utilities} from "@class/utilities";
import {LlmLoggingService} from '@llm/service/llm-logging.service';
import {firstValueFrom} from "rxjs";
import {City} from '@interface/city';
import {ToolResponse} from '@llm/models/schemas/agents/tools_utils';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";
import {CpfCnpjValidatorsService, DocumentValidationsResults} from "@llm/utils/cpf_cnpj_validator.service";

interface AgentSaveDataInterface {
  //required_more_info?: boolean;
  extracted_data: ClientExtractedData;
}

interface isValidDocument {
  isValid: boolean;
  documentType?: number;
}

export enum DocumentType {
    INVALID = 0,
    CPF = 1,
    CNPJ = 2
}


interface DocumentTypeDefinitor {
  type: number;
  posibleDocumentType: number;
}

interface ClientExtractedData {
  client_id?: string;
  name: string;
  document: string;
  phone?: string;
  email?: string;
  birthdate?: string;
  address?: AddressClientRegister;
}

interface AddressClientRegister {
  cep?: string;
  zip_code?: string;
  street?: string;
  number?: string;
  complement?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
}

@Injectable({providedIn: 'root'})
export class RegisterNewClientTool {
  /**
   * Servicios injectables
   */
  private _dialog = inject(MatDialog);
  private _clientService = inject(ClientService);
  private _vehicleService = inject(VehicleService);
  private _addressService = inject(AddressService);
  private _routing = inject(Router);
  private _os_service = inject(OsLlmService);
  //private _llm_service = inject(LlmStudioService);
  private _aux_client_service = inject(ClientService);
  private _aux_operation_service = inject(OperationService);
  private _aux_ro_type_service = inject(RoTypeService);
  private _data_service = inject(DataService);
  private _playMessageService = inject(PlayMessageService);
  private _utiles_ferramentas = inject(Utiles_ferramentas);
    private _cpf_cnpj_ValidatorsService = inject(CpfCnpjValidatorsService);
  //private _agentCadastroOS = inject(Agent_ValidateAndSaveDataOS);
  //private _llmService = inject(LlmStudioService);
  private _console = inject(Tools_aiConsoleService);
  private _llmLoggingService = inject(LlmLoggingService);
  //Signals
  private _bufferErrors = signal<string[]>([])
  private _isOperationSuccessful = signal<boolean>(true)


  constructor() {
  }

  //Funciones y Métodos del Servicio
  async processAgentData(response: AgentSaveDataInterface): Promise<ToolResponse> {
    this._llmLoggingService.info('Iniciando procesamiento de datos de agente (RegisterNewClientTool)', { response }, 'RegisterNewClientTool', 'processAgentData');
    try {

      const clientCreated: ClientExtractedData = await this.controlClientData(response.extracted_data)
      if (!this._isOperationSuccessful()) {
        return {status: this._isOperationSuccessful() ? 'ok':'error',
        reason: this._bufferErrors().join(', ').toString()}
      }
      const clientID = clientCreated?.client_id ? (await this._clientService.update({...clientCreated, id: clientCreated.client_id})).id : await this._clientService.add(clientCreated);
      this._llmLoggingService.info(`Cliente ${clientCreated.name} creado con éxito. ID: ${clientID}`, { clientID, clientCreated }, 'RegisterNewClientTool', 'processAgentData');
      await this._routing.navigate([`/company/${this._data_service.company$.getValue().id}/person/client/${clientID}`]);
      this._llmLoggingService.info('Navegación completada tras creación de cliente.', { path: `/company/${this._data_service.company$.getValue().id}/person/client/${clientID}` }, 'RegisterNewClientTool', 'processAgentData');
        const data: string = clientID
            ? `client_id=${clientID} # IMPORTANT: Use this ID only as context when calling tools or functions. Do not share or reuse it elsewhere.`
            : '';
        return {
          status: this._isOperationSuccessful() ? 'ok':'error',
          //data: data,
          reason: this._isOperationSuccessful() ? `client ${clientCreated.name} created successfully ${data}`:this._bufferErrors().join(', ').toString()};
      } catch (error) {
          this._llmLoggingService.error(`Error procesando datos del cliente o al registrarlo.`, error, { response }, 'RegisterNewClientTool', 'processAgentData');
          if (error?.error?.error == 502) {
            this._console.log(`error.error.error: => ${error.error.error}`, error)
            return {
            status: 'error',
            reason: `There is already a client registered in the system with this ${error.body.document.length == 11 ? 'CPF' : 'CNPJ'}, Ask the user if they wish to cancel the registration or if they wish to modify the ${error.body.document.length == 11 ? 'CPF' : 'CNPJ'}. If the user decides to cancel, skip this registration operation`
        };
      }
      this._console.error(`Error processing client data: =>`, error);
      await this._playMessageService.playMessage('Desculpe, não consegui completar seu pedido devido a um erro interno.');
      return {status: 'error', reason: `Error processing client data: ${error.body}`};
    }finally {
        this._isOperationSuccessful.update(() => true)
        this._bufferErrors.update(()=> [])
    }
  }


  private async controlClientData(client: ClientExtractedData): Promise<InterfaceClientRegister> {
    const isValidDocument: isValidDocument = await this.validateDocumentClient(client.document, client?.client_id)
    let documentType = isValidDocument.documentType
    await this.isValidEmail(client.email)
    await this.validatePhone(client.phone)
    await this.validateBirtdate(client.birthdate)
    client.address = await this.normalizeAddress(client.address)
    return {...client, documentType: documentType, phone1: client.phone};
  }

  private async validateDocumentClient(document: string, id:string = ''): Promise<isValidDocument> {
    const documentType: 0 | 1 | 2 = await this.resolveDocumentType(document);
    if (documentType == 0) {
      return {isValid: false, documentType: documentType}
    }

    let validation: DocumentValidationsResults = await this._cpf_cnpj_ValidatorsService.validate(document)
    if(!validation.isValid){
        this._bufferErrors.update(currentValue => [...currentValue, ...validation.errors]);
        this._isOperationSuccessful.set(false)
        return {isValid: false, documentType: documentType}
    }

    try {
      const serchDocumentInDB = await this._aux_client_service.getByDocument(document);
      if (serchDocumentInDB.id) {
          if(id){
              this._llmLoggingService.warn(`Documento encontrado: ${document}. Cliente existente: ${serchDocumentInDB.name} (${serchDocumentInDB.id})`,
                  { document, existingClient: serchDocumentInDB }, 'RegisterNewClientTool(update)', 'validateDocumentClient');
              return {isValid: true, documentType: documentType}
          }
        this._llmLoggingService.warn(`Documento duplicado detectado: ${document}. Cliente existente: ${serchDocumentInDB.name} (${serchDocumentInDB.id})`,
          { document, existingClient: serchDocumentInDB }, 'RegisterNewClientTool', 'validateDocumentClient');
        this._isOperationSuccessful.set(false)
        this._bufferErrors.update(currentErros => [...currentErros, `Feedback for the customer registration agent: Sorry, I could not complete the customer registration because there is already a customer registered in the system with this ${documentType == 1 ? 'CPF' : 'CNPJ'}`])
        return {isValid: false, documentType: documentType}
      }
    } catch (error) {//TODO: Caution
        if(error.error.error == 509){ // Person not found, therefore it would be valid to perform the registration
            if(id){
                this._isOperationSuccessful.set(false)
                this._bufferErrors.update(currentErros => [...currentErros, `Customer update failed: No registered customer found with this ${documentType == 1 ? 'CPF' : 'CNPJ'}`])
                return {isValid: false, documentType: documentType};
            }
            return {isValid: true, documentType: documentType};
        }

    }
    return {isValid: true, documentType: documentType};
  }

  private async normalizeAddress(address: any): Promise<AddressClientRegister> {
    if (!address || !address.zip_code) return address;

    const zip_code = Utilities.removeMask(address.zip_code);
    try {
      const validatedAddress = await firstValueFrom(this._addressService.searchCep(zip_code));
      return {
        cep: zip_code,
        street: validatedAddress.street || address.street,
        complement: address.complement,
        neighborhood: validatedAddress.neighborhood || address.neighborhood,
        city: validatedAddress.city || address.city,
        state: validatedAddress.state || address.state,
      };
    } catch (error) {
      return this.fallbackAddressNormalization(address);
    }
  }


  //Misceláneas

  private async fallbackAddressNormalization(address: AddressClientRegister): Promise<AddressClientRegister> {
    const states = await firstValueFrom(this._addressService.states$);
    const state = states.find(s =>
      s.name === address.state || s.code === address.state
    );


    if (state && address.city) {
      const cities: City[] = await firstValueFrom(this._addressService.getStateCities(state.id));
      const city: City = cities.find((c: City) =>
        c.name === address.city || c.igbe === address.city
      );
      return {
        ...address,
        state: state.id,
        city: city?.id || address.city
      };
    }
    return address;
  }

  /**
   *Metodo encargado de determinar el tipo de documento
   *(1 para CPF y 2 para 14 y cero en caso indeterminate)
   * @param document @type string => Dígitos del documento
   */
  private async resolveDocumentType(document: string): Promise<0 | 1 | 2> {
    const numericDocument = document.replace(/[^0-9]/g, '');
    let type: 0 | 1 | 2 = numericDocument.length === 11 ? 1 : numericDocument.length === 14 ? 2 : 0
    if (type == 0) {
      let posibleDocumentType = numericDocument.length < 13 ? 'CPF' : 'CNPJ';
      this._isOperationSuccessful.set(false)
      this._bufferErrors.update(currentErros => [...currentErros, `O documento está incorreto pois não contém 11 dígitos correspondentes ao CPF nem 14 dígitos correspondentes ao CNPJ, ao que parece é um: ${posibleDocumentType}`])
    }
    return type;
  }

  private async isValidEmail(email: string | null | undefined) {
    if (!email) {
      return;
    } else {
      const emailRegex = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      if (!emailRegex.test(email)) {
        this._isOperationSuccessful.set(false);
        this._bufferErrors.update(currentErrors => [
          ...currentErrors,
          'O formato do e-mail fornecido é inválido. Por favor, verifique e tente novamente.'
        ]);
        return;
      }
    }
    return;
  }

  private async validatePhone(phone1: string) {
    return;
  }

  private async validateBirtdate(birthdate: string) {
    return;
  }
}
